const buildRoomMediaList = ({ images = [], video } = {}) => {
  const imageItems = images.map((item, index) => {
    if (typeof item === 'string') {
      return {
        id: `image-${index}`,
        image: item,
        isVideo: false,
      };
    }

    return {
      ...item,
      id: item.id || `image-${index}`,
      image: item.image || item.url || item,
      isVideo: false,
    };
  });

  const videoItems = [];

  if (video) {
    const videos = Array.isArray(video) ? video : [video];

    videos.filter(Boolean).forEach((videoUrl, index) => {
      videoItems.push({
        id: `video-${index}-${videoUrl}`,
        image: videoUrl,
        isVideo: true,
      });
    });
  }

  return [...imageItems, ...videoItems];
};

export default buildRoomMediaList;
